import Accordion from "react-bootstrap/Accordion";
import Footer from "./small/Footer";
import { Icon } from "@iconify/react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Link } from "react-router-dom";

const topRaffles = [
  {
    firstImg: "../../../assets/images/topraffle/img1.png",
    profImg: "../../../assets/images/topraffle/img2.png",
    title: "Cyber Girl Smoke ",
    inStock: "8",
    price: "145.55",
    userImg: "../../../assets/images/topraffle/img3.png",
    userName: "Nina Hazel",
  },
  {
    firstImg: "../../../assets/images/topraffle/main2.png",
    profImg: "../../../assets/images/topraffle/img2.png",
    title: "Cyber Girl Smoke ",
    inStock: "8",
    price: "145.55",
    userImg: "../../../assets/images/topraffle/img3.png",
    userName: "Nina Hazel",
  },
  {
    firstImg: "../../../assets/images/topraffle/main3.png",
    profImg: "../../../assets/images/topraffle/img2.png",
    title: "Cyber Girl Smoke ",
    inStock: "8",
    price: "145.55",
    userImg: "../../../assets/images/topraffle/img3.png",
    userName: "Nina Hazel",
  },
  {
    firstImg: "../../../assets/images/topraffle/main4.png",
    profImg: "../../../assets/images/topraffle/img2.png",
    title: "Cyber Girl Smoke ",
    inStock: "8",
    price: "145.55",
    userImg: "../../../assets/images/topraffle/img3.png",
    userName: "Nina Hazel",
  },
];

const PhysicalDetails = () => {
  const percentage1 = 50;
  const percentage2 = 70;
  const changeImage = (e) => {
    const prodImage = document.getElementById("product-image");
    prodImage.src = e.target.currentSrc;
  };
  return (
    <>
      <main className="nft-detail-bg">
        <section className="physical-product">
          <div className="container">
            <div className="row">
              <div className="col-sm-4">
                <img
                  id="product-image"
                  className="physical-img img-fluid"
                  src="../../../assets/images/physicalproduct/img1.png"
                />
                <div className="d-flex thumbnails">
                  <img
                    key="1"
                    className="physical-img img-fluid"
                    src="../../../assets/images/physicalproduct/img1.png"
                    onClick={(e) => changeImage(e)}
                  />
                  <img
                    key="2"
                    className="physical-img img-fluid"
                    src="../../../assets/images/physicalproduct/img2.png"
                    onClick={(e) => changeImage(e)}
                  />
                  <img
                    key="3"
                    className="physical-img img-fluid"
                    src="../../../assets/images/physicalproduct/img3.png"
                    onClick={(e) => changeImage(e)}
                  />
                  <img
                    key="4"
                    className="physical-img img-fluid"
                    src="../../../assets/images/physicalproduct/img4.png"
                    onClick={(e) => changeImage(e)}
                  />
                </div>
              </div>
              <div className="col-sm-8">
                <h3 className="nft-title">Moon rabbits t-shirt</h3>
                <div className="four-items">
                  <h3 className="ownedby">
                    Owned By: <span>Nina Hazel</span>
                  </h3>

                  <div className="views">
                    {/* <img src="../../public/assets/images/icons" alt="" /> */}
                    <Icon className="ivon" icon="carbon:view-filled" />
                    750 views
                  </div>

                  <div className="likes">
                    <Icon className="ivon" icon="bi:heart-fill" />
                    100 Favorites
                  </div>

                  <div className="more-options">
                    <Icon icon="ic:baseline-refresh" />
                    <Icon icon="akar-icons:link-out" />
                    <Icon icon="entypo:share" />
                    <Icon icon="bi:three-dots" />
                  </div>
                </div>

                <h3 className="currentprice">Current Price</h3>

                <div className="priceandbuybtn">
                  <div className="price-wrapper">
                    <img
                      className="crypto-ico"
                      src="../../assets/images/icons/cryptocurrency_eth.png"
                      alt=""
                    />
                    15.60 <span>$450</span>
                  </div>

                  <div className="buy-makeoffer">
                    <button className="buybtn">Buy </button>
                    <Link to="/cart" className="makeoffer">
                      Add to cart
                    </Link>
                  </div>
                </div>

                <div className="thre-boxed">
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="delivery-wrap">
                        <h3 className="delivery-title">Delivery</h3>
                        <p className="location">
                          <Icon icon="fontisto:map-marker-alt" />
                          All Across The World
                        </p>

                        <div className="anotherborder"></div>
                        <div className="sd-wrapper">
                          <div>
                            <h6 className="standard-tit">Standard Delivery</h6>
                            <p className="location">
                              <Icon icon="fluent:shopping-bag-arrow-left-24-filled" />
                              5-7 days
                            </p>
                          </div>
                          <p className="price-shipping">USD : 109</p>
                        </div>
                        <div className="anotherborder"></div>
                        <div className="cashondeliverywrapper">
                          <h6 className="cashon">Cash On Delvery Available</h6>
                          <p style={{ color: "#DFC500", marginBottom: "0" }}>
                            Yes
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="delivery-wrap">
                        <h3 className="delivery-title">Product Detail</h3>
                        <p className="location color">Color :</p>
                        <label>
                          <input
                            className="color-radio"
                            type="radio"
                            name="test"
                            value="#FFB1A0"
                            onChange={(e) => {
                              console.log(e.target.value);
                            }}
                          />
                          <img
                            className="color-img"
                            src="../../assets/images/physicalproduct/color1.png"
                            alt="Option 1"
                          />
                        </label>

                        <label>
                          <input
                            className="color-radio"
                            type="radio"
                            name="test"
                            value="#CB5F48"
                            onChange={(e) => {
                              console.log(e.target.value);
                            }}
                          />
                          <img
                            className="color-img"
                            src="../../assets/images/physicalproduct/color2.png"
                            alt=""
                          />
                        </label>
                        <label>
                          <input
                            className="color-radio"
                            type="radio"
                            name="test"
                            value="#CB48B6"
                            onChange={(e) => {
                              console.log(e.target.value);
                            }}
                          />
                          <img
                            className="color-img"
                            src="../../assets/images/physicalproduct/color3.png"
                            alt=""
                          />
                        </label>
                        <label>
                          <input
                            className="color-radio"
                            type="radio"
                            name="test"
                            value="#48CB94"
                            onChange={(e) => {
                              console.log(e.target.value);
                            }}
                          />
                          <img
                            className="color-img"
                            src="../../assets/images/physicalproduct/color4.png"
                            alt=""
                          />
                        </label>

                        <div className="anotherborder"></div>

                        <div className="size-wrapper">
                          <p className="location color">Size :</p>
                          <label>
                            <input
                              className="size"
                              type="radio"
                              name="size"
                              value="small"
                              onChange={(e) => {
                                console.log(e.target.value);
                              }}
                            />
                            <h3 className="sizelabel">S</h3>
                          </label>
                          <label>
                            <input
                              className="size"
                              type="radio"
                              name="size"
                              value="M"
                              onChange={(e) => {
                                console.log(e.target.value);
                              }}
                            />
                            <h3 className="sizelabel">M</h3>
                          </label>

                          <label>
                            <input
                              className="size"
                              type="radio"
                              name="size"
                              value="l"
                              onChange={(e) => {
                                console.log(e.target.value);
                              }}
                            />
                            <h3 className="sizelabel">L</h3>
                          </label>
                          <label>
                            <input
                              className="size"
                              type="radio"
                              name="size"
                              value="xl"
                              onChange={(e) => {
                                console.log(e.target.value);
                              }}
                            />
                            <h3 className="sizelabel">XL</h3>
                          </label>

                          <label>
                            <input
                              className="size"
                              type="radio"
                              name="size"
                              value="xxl"
                              onChange={(e) => {
                                console.log(e.target.value);
                              }}
                            />
                            <h3 className="sizelabel">XXL</h3>
                          </label>
                        </div>

                        <div className="anotherborder"></div>
                        <div className="cashondeliverywrapper">
                          <h6 className="cashon">Quantity</h6>
                          <p style={{ color: "#DFC500", marginBottom: "0" }}>
                            200 pieces
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="delivery-wrap">
                        <h3 className="delivery-title">Sold By</h3>
                        <p className="location">
                          Smart Shop by CyberPunk (USA) New York
                        </p>

                        <div className="anotherborder"></div>
                        <div className="two-cols-wrapper">
                          <div className="left-col">
                            <h3 className="post-seller">Positive Seller</h3>
                            <CircularProgressbar
                              value={percentage1}
                              text={`${percentage1}%`}
                              styles={buildStyles({
                                // Rotation of path and trail, in number of turns (0-1)
                                rotation: 0.25,

                                // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                strokeLinecap: "butt",

                                // Text size
                                textSize: "16px",

                                // How long animation takes to go from one percentage to another, in seconds
                                pathTransitionDuration: 0.5,

                                // Can specify path transition in more detail, or remove it entirely
                                // pathTransition: 'none',

                                // Colors
                                pathColor: `rgba(223, 197, 0, ${
                                  percentage1 / 100
                                })`,
                                textColor: "#fff",
                                trailColor: "#d6d6d6",
                                backgroundColor: "#3e98c7",
                              })}
                            />
                          </div>

                          <div className="right-col">
                            <h3 className="post-seller">Positive Seller</h3>

                            <CircularProgressbar
                              value={percentage2}
                              text={`${percentage2}%`}
                              styles={buildStyles({
                                rotation: 0.25,

                                // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                strokeLinecap: "butt",

                                // Text size
                                textSize: "16px",

                                // How long animation takes to go from one percentage to another, in seconds
                                pathTransitionDuration: 0.5,

                                // Can specify path transition in more detail, or remove it entirely
                                // pathTransition: 'none',

                                // Colors
                                pathColor: `rgba(223, 197, 0, ${
                                  percentage1 / 100
                                })`,
                                textColor: "#fff",
                                trailColor: "#d6d6d6",
                                backgroundColor: "#3e98c7",
                              })}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-4">
                      <div className="delivery-wrap text-center mt-3">
                        <h3 className="delivery-title">Owned By</h3>
                        <img
                          src="../../assets/images/physicalproduct/moon.png"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="top-raffles">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="title">
                  <h2 className="main-tite nft-details-more-collection">
                    <span> &#91;</span>More Collections <span> &#93;</span>
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              {topRaffles.map((item, index) => {
                return (
                  <div className="col-sm-3" key={index}>
                    <div className="top-raffle-single">
                      <div className="heart-love text-end">
                        <div className="icon-wrapping-hears">
                          <Icon
                            icon="ant-design:heart-filled"
                            className="heart-icon-single"
                          />
                          <span>1.2k</span>
                        </div>
                      </div>
                      <img
                        className="top-raffle-single-img"
                        src={item.firstImg}
                      />
                      <div className="d-flex align-items-center top-raffle-first">
                        <img
                          className="top-raffle-prof-imgp"
                          src={item.profImg}
                        />

                        <h3 className="raffle-it">{item.title}</h3>
                      </div>

                      <div className="d-flex align-items-center justify-content-between top-raffle-second">
                        <h3 className="instock">
                          in stock <span>{item.inStock}</span>
                        </h3>
                        <div className="d-flex align-items-center justify-content-between price">
                          <h3 className="price-tit">
                            price:
                            <img
                              className="etheriumico"
                              src="../../../assets/images/topraffle/img4.png"
                            />
                            <span>{item.price}</span>
                          </h3>
                        </div>
                      </div>
                      <div className="forborder-bott"></div>

                      <div className="d-flex align-items-center bottom-items justify-content-between top-raffle-third">
                        <div className="d-flex align-items-center">
                          <img
                            className="top-raffle-prof-imgp"
                            src={item.userImg}
                          />

                          <h3 className="seller-name">{item.userName}</h3>
                        </div>
                        <div>
                          <button className="place-bid">Place bid</button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </>
  );
};
export default PhysicalDetails;
